import React, { useEffect, useState } from "react";
import apiClient from "../api/apiClient";
import Timeline from "../components/Experience";

const Resume = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    apiClient.getResume()
      .then((content) => active && setData(content))
      .catch(() => active && setError("Unable to load the resume."));
    return () => { active = false; };
  }, []);

  if (error) return <div className="page-shell py-20 text-center text-muted">{error}</div>;
  if (!data) return <div className="page-shell py-20 text-center font-mono text-xs uppercase tracking-widest text-muted">Loading resume…</div>;

  return (
    <section className="page-enter">
      <header className="grid-bg border-b border-line">
        <div className="page-shell py-20 md:py-28">
          <div className="mb-6 flex items-center gap-5"><span className="eyebrow">Record // Experience</span><span className="font-mono text-[9px] uppercase tracking-widest text-muted">Updated continuously</span></div>
          <h1 className="font-display text-5xl font-semibold tracking-[-0.055em] text-textmain md:text-8xl">Résumé<span className="text-accent">.</span></h1>
          <p className="mt-6 max-w-2xl text-base leading-7 text-muted">A chronological record of engineering work, education, tools, and credentials.</p>
        </div>
      </header>

      <div className="page-shell py-20 md:py-28">
        <section>
          <div className="grid gap-5 border-b border-line pb-7 md:grid-cols-[150px_1fr]"><span className="section-index">01 / Timeline</span><h2 className="section-title">{data.timelineSection.title}</h2></div>
          <div className="mt-10">
            <Timeline events={data.timelineSection.events} />
          </div>
        </section>

        <section className="mt-24 md:mt-32">
          <div className="grid gap-5 border-b border-line pb-7 md:grid-cols-[150px_1fr]"><span className="section-index">02 / Toolkit</span><h2 className="section-title">{data.skillsSection.title}</h2></div>
          <div className="grid border-l border-line sm:grid-cols-2 lg:grid-cols-4">
            {data.skillsSection.groups.map((group) => (
              <article key={group.label} className="border-b border-r border-line bg-card p-6 md:min-h-56">
                <h3 className="eyebrow text-textmain">{group.label}</h3>
                <ul className="mt-7 space-y-3">{group.skills.map((skill) => <li key={skill} className="flex items-center gap-3 text-sm text-muted"><span className="h-px w-3 bg-accent" />{skill}</li>)}</ul>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-24 md:mt-32">
          <div className="grid gap-5 border-b border-line pb-7 md:grid-cols-[150px_1fr]"><span className="section-index">03 / Credentials</span><div><h2 className="section-title">{data.credentialsSection.title}</h2><p className="mt-4 max-w-2xl text-sm leading-7 text-muted">{data.credentialsSection.description}</p></div></div>
          <div className="grid gap-10 py-9 md:ml-[150px] lg:grid-cols-2">
            <div><p className="eyebrow mb-4">Languages</p>{data.credentialsSection.languages.map((language) => <div key={language.name} className="flex justify-between gap-6 border-t border-line py-4 text-sm"><span className="text-textmain">{language.name}</span><span className="font-mono text-[10px] uppercase text-muted">{language.level}</span></div>)}</div>
            <div><p className="eyebrow mb-4">Certifications</p>{data.credentialsSection.credentials.map((credential) => <div key={credential.name} className="border-t border-line py-4"><p className="text-sm text-textmain">{credential.name}</p><p className="mt-1 font-mono text-[9px] uppercase tracking-wide text-muted">{credential.issuer}</p></div>)}</div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default Resume;
